// List of OWS APIs that should go through .net core service
export const netcoreAPI = new Set([
    'GetFolder',
    'FindItem',
    'FindConversation',
    'FindFolder',
    'GetUserUnifiedGroups',
    'GetTimeZone',
]);
